__turbopack_context__.v({
  "center": "StarRating-module__37pSha__center",
  "fieldSetContainer": "StarRating-module__37pSha__fieldSetContainer",
  "inputLabel": "StarRating-module__37pSha__inputLabel",
  "ratingText": "StarRating-module__37pSha__ratingText",
  "stars": "StarRating-module__37pSha__stars",
  "styledFieldset": "StarRating-module__37pSha__styledFieldset",
  "text": "StarRating-module__37pSha__text",
  "textFirst": "StarRating-module__37pSha__textFirst",
  "visuallyHiddenInput": "StarRating-module__37pSha__visuallyHiddenInput",
});
